<template>
  <div class="site-loader">
    <div class="blocker"></div>
    <div class="loader-container">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.site-loader {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 20;

  .blocker {
    background-color: #000;
    height: 100vh;
    opacity: 0.6;
    position: absolute;
    width: 100vw;
  }

  .loader,
  .loader::after {
    border-radius: 50%;
    height: 10em;
    width: 10em;
  }

  .loader {
    animation: load8 1.1s infinite linear;
    border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
    border-left: 1.1em solid #fff;
    border-right: 1.1em solid rgba(255, 255, 255, 0.2);
    border-top: 1.1em solid rgba(255, 255, 255, 0.2);
    font-size: 10px;
    margin: 60px auto;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
  }
  @keyframes load8 {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
